export default "__VITE_ASSET__h1zI5Twp__"